import { render, staticRenderFns } from "./PesquisaClientes.vue?vue&type=template&id=71d0aeb4&"
import script from "./PesquisaClientes.vue?vue&type=script&lang=js&"
export * from "./PesquisaClientes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports